/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Status_Mixdown_CompleteInputs */



/**
* | output |
* | --- |
* | "Audio mixdown complete!" |
*
* @param {Audio_Description_Export_Status_Mixdown_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_mixdown_complete = /** @type {((inputs?: Audio_Description_Export_Status_Mixdown_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Mixdown_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mixdown audio terminé !")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audiomixdown abgeschlossen!")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mixaggio audio completato!")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сведение звука завершено!")
	if (locale === "es") return /** @type {LocalizedString} */ ("¡Mezcla de audio completada!")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("音频混音完成！")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオミックスダウンが完了しました！")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो मिक्सडाउन पूरा हो गया!")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mixagem de áudio concluída!")
	return /** @type {LocalizedString} */ ("Audio mixdown complete!")
});